<template>
    <div id="dropdown">
        <label ref="label-id" :for="name"> {{ labelPartOne }} <span style="white-space:nowrap;">{{ labelPartTwo }} <span id="tooltip-id" ref="tooltip-id" @mouseover="showTooltip" @mouseleave="hideTooltip" v-show="hasTooltip" class="label-tooltip rounded-circle">?<span v-show="activeTooltip" class="calc-tooltip" style="white-space: pre-line;">{{ tooltipText }}<div class="arrow-down"></div></span></span></span></label>
        <div class="input-group  mb-3">
            <input readonly type="text" v-model="selectedOption" class="form-control dropdown-text" data-toggle="dropdown" aria-label="Text input with segmented dropdown button">
            <div class="input-group-append">
                <button type="button" class="btn btn-outline-secondary dropdown-toggle dropdown-toggle-split" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                    <span class="sr-only">Toggle Dropdown</span>
                </button>
                <div class="dropdown-menu">

                    <a class="dropdown-item" v-for="option in options" v-on:click="selectOption(option)" href="#">
                        {{ option }}
                    </a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "dropdown",
        data () {
            return {
                activeTooltip: false
            }
        },
        props: {
            name: String,
            label: String,
            options: Array,
            selectedOption: String,
            hasTooltip: Boolean
        },
        methods: {
            showTooltip: function () {
                this.activeTooltip = true;
            },
            hideTooltip: function () {
                this.activeTooltip = false;
            },
            selectOption: function (option) {
                this.selectedOption = option;

                this.$emit('changeOption', this.selectedOption);
            }
        },
        computed: {
            labelPartOne: function () {
                return this.label.substring(0, this.label.lastIndexOf(" ") + 1);
            },
            labelPartTwo: function () {
                return this.label.substring(this.label.lastIndexOf(" ") + 1);
            },
            tooltipText: function () {
                var helpText = "";

                switch (this.name) {
                    case 'Property-Type':
                        helpText = "Properties have been defined according to the following broad definitions: \n" +
                            "House / Townhouse - Any freestanding residential property or a strata titled residential \n" +
                            "building up to two levels above ground, the property may be adjoining other units within the complex \n" +
                            "Unit - Residential strata titled unit in a building with no lift \n" +
                            "Highrise - Residential strata titled unit in a building with a lift \n" +
                            "Commercial Property - Wholly owned commercial building or strata titled office \n" +
                            "Industrial Property - Wholly owned industrial building or one of many industrial units \n";
                        break;
                    case 'Construction-Year':
                        helpText = "The approximate year the building construction commenced. " +
                            "If unknown the local council may be able to assist";
                        break;
                }

                return helpText;
            }
        },
        mounted () {
            let $vm = this;
            var tooltip = this.$refs['tooltip-id'];
            tooltip.addEventListener('touchstart', function () {
                $vm.activeTooltip = !$vm.activeTooltip;
            });

            var dropdownOptions = document.getElementsByClassName("dropdown-item");

            for (var i = 0; i < dropdownOptions.length; i++) {
                dropdownOptions[i].addEventListener('click', function (e) {
                    e.preventDefault();
                })
            }
        }
    }
</script>

<style scoped>

    label {
        float: left;
        font-size: 20px;
        color: #465978;
        width: 48% !important;
        margin-top: -7px;
        margin-bottom: 15px;
    }

    .input-group {
        width: 50%;
        margin-left: auto;
        margin-top: 0;
        align-self: start
    }

    #dropdown {
        width: 85%;
        margin: 0 auto;
        display: flex;
    }

    .dropdown-text {
        background-color: #fff;
        cursor: pointer;
    }

    .dropdown-menu {
        height: auto;
        max-height: 280px;
        overflow-x: hidden;
        overflow-y: scroll;
        -webkit-overflow-scrolling:touch;
    }

    ::-webkit-scrollbar {
        -webkit-appearance: none;
        -webkit-overflow-scrolling: auto
    }

    ::-webkit-scrollbar:vertical {
        width: 12px;
        -webkit-overflow-scrolling: auto
    }

    ::-webkit-scrollbar:horizontal {
        height: 12px;
        -webkit-overflow-scrolling: auto
    }

    ::-webkit-scrollbar-thumb {
        background-color: rgba(0, 0, 0, .5);
        border-radius: 10px;
        border: 2px solid #ffffff;
        -webkit-overflow-scrolling: auto
    }

    ::-webkit-scrollbar-track {
        border-radius: 10px;
        background-color: #ffffff;
        -webkit-overflow-scrolling: auto
    }

    .label-tooltip {
        background-color: #ee3124;
        width: 20px;
        border-radius: 50%;
        color: white;
        font-weight: bold;
        font-size: 16px;
        display: inline-block;
        font-family: 'Roboto', Arial, serif;
        position: relative;
        cursor: pointer;

        height: 0;
        padding: 10px 0%;
        line-height: 0;
        text-align: center;
    }

    .calc-tooltip {
        position: absolute;
        z-index: 99;
        top: -60px;
        left: 0px;
        background-color: #465978;
        height: 58px;
        width: 250px;
        color: #fff;
        line-height: 16px;
        padding: 8px;
        opacity: 0.9;
        margin-left: -475%;
        overflow: hidden;
        white-space: normal;
    }

    .arrow-down {
        width: 0;
        height: 0;
        border-left: 10px solid transparent;
        border-right: 10px solid transparent;
        border-top: 10px solid black;
        margin-left: 88px;
        margin-bottom: 0;
        margin-top: 5px;
    }

    .property-type .calc-tooltip {
        width: 310px;
        height: 329px;
        top: -330px;
        margin-left: -475%;
    }

    .property-type .arrow-down {
        margin-left: 88px;
    }

    .construction-year .calc-tooltip {
        width: 260px;
        height: 105px;
        top: -106px;
        margin-left: -475%;
    }

    .construction-year .arrow-down {
        margin-left: 88px;
    }

    @media (min-width: 1250px) and (max-width: 1410px) {
        .construction-year label {
            width: 183px;
        }
    }

    @media (min-width: 1186px) and (max-width: 1250px) {
        .construction-year label {
            width: 155px;
        }
    }

    @media (min-width: 1050px) and (max-width: 1153px) {
        .property-type label {
            width: 149px;
        }
    }

    @media (min-width: 1024px) and (max-width: 1050px) {
        .property-type label {
            width: 122px;
        }
    }

    @media (max-width: 1128px) {
        .property-type .calc-tooltip {
            margin-left: -115%;
        }

        .property-type .arrow-down {
            margin-left: 15px;
        }
    }

    @media (min-width: 1024px) {
        #dropdown {
            margin-bottom: 12px;
        }

        label {
            margin-bottom: 0;
        }
    }

    @media (max-width: 768px) {

        .construction-year .calc-tooltip {
            margin-left: -145%;
        }

        .construction-year .arrow-down {
            margin-left: 21px;
        }
    }

    @media (max-width: 470px) {
        .input-group {
            width: 50%;
        }

        .dropdown-text {
            font-size: 20px;
        }

        .property-type .calc-tooltip {
        margin-left: -475%;
        }

        .property-type .arrow-down {
        margin-left: 88px;
        }
    }

    @media (max-width: 394px) {
        .property-type .calc-tooltip {
            width: 270px;
            height: 344px;
            top: -345px;
        }
    }

    @media (max-width: 364px) {
        .property-type .calc-tooltip {
            margin-left: -225%;
        }

        .property-type .arrow-down {
            margin-left: 37px;
        }
    }

</style>


// WEBPACK FOOTER //
// src/Components/Dropdown.vue